"use client"

import { useMemo } from "react"
import { NpColorCards, NpProductColorCardValueProps } from "src/components/product-details/buyBox/NpProductColorCards"
import { createResolvedProductData } from "src/components/product-details/createResolvedProductData"
import { useEventCallback } from "src/hooks/useEventCallback"
import { useProductContext } from "../context"
import { setSelectedSkuBySlug } from "../state"

export const ProductTiles = () => {
  const resolvedProduct = useProductContext()
  const { variations, product, variation } = resolvedProduct

  const options = useMemo(() => {
    return (variations || []).map<NpProductColorCardValueProps>((variation) => ({
      product: createResolvedProductData(product, variation),
      value: {
        name: variation.name,
        image: variation.tileImage,
      },
    }))
  }, [variations, product])

  const onChange = useEventCallback((value: string) => {
    const variation = variations?.find((variation) => variation.name === value)

    if (variation) {
      setSelectedSkuBySlug(product.slug, variation.sku)
    }
  })

  if (!variations || variations.length < 2) {
    return null
  }

  const value = variation?.name

  return <NpColorCards options={options} value={value} onChange={onChange} />
}
